export default __webpack_public_path__ + "static/069-a7f73d54166ca58eb219fd5b0cffde0e.jpg";